import { render, staticRenderFns } from "./BeCalm.vue?vue&type=template&id=f6408904"
import script from "./BeCalm.vue?vue&type=script&lang=js"
export * from "./BeCalm.vue?vue&type=script&lang=js"
import style0 from "./BeCalm.vue?vue&type=style&index=0&id=f6408904&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports